export default __webpack_public_path__ + "static/media/FIU_CEC.5118bf7d.svg";